function initializeVideoPlayer(videoContainer) {
    var video = videoContainer.querySelector('.video');
    var playButton = videoContainer.querySelector('.play-button');

    playButton.addEventListener('click', function() {
        if (video.paused || video.ended) {
            video.play();
            playButton.style.display = 'none';
        } else {
            video.pause();
        }
    });

    video.addEventListener('click', function() {
        if (!video.paused) {
            video.pause();
            playButton.style.display = 'block';
        }
    });

    video.addEventListener('ended', function() {
        playButton.style.display = 'block';
    });
}

// Initialize video players
var videoContainers = document.querySelectorAll('.video-container');
videoContainers.forEach(function(videoContainer) {
    initializeVideoPlayer(videoContainer);
});